export enum HTTP_HEADER_KEY {
    ContentType = 'Content-Type',
    ActivePodId = 'Active-Pod-Id',
    Authorization = 'Authorization'
}
